export const Footer = () => (
  <footer data-testid="site-footer" className="bg-foreground text-background pt-20 pb-10">
    <div className="px-5 md:px-10 max-w-[1400px] mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 border-b border-white/15 pb-14">
        <div className="md:col-span-6">
          <p className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-none">
            Let's build a<br /> better practice.
          </p>
          <a
            href="#booking"
            data-testid="footer-cta"
            className="inline-block mt-8 bg-primary text-primary-foreground font-semibold px-7 py-4 hover:-translate-y-0.5 transition-transform duration-200"
          >
            Book a discovery call
          </a>
        </div>
        <div className="md:col-span-3 md:col-start-8">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-white/50 mb-4">Contact</p>
          <a href="mailto:hello@place-ventures.com" className="block hover:text-primary transition-colors duration-200">
            hello@place-ventures.com
          </a>
          <p className="text-white/50 mt-2 text-sm">Australia · Remote</p>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-white/50 mb-4">Explore</p>
          <div className="flex flex-col gap-2">
            <a href="#services" className="hover:text-primary transition-colors duration-200">Services</a>
            <a href="#manifesto" className="hover:text-primary transition-colors duration-200">Approach</a>
            <a href="#audience" className="hover:text-primary transition-colors duration-200">Who we help</a>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 text-sm text-white/50">
        <img
          src="https://customer-assets-v7afamib.emergentagent.net/job_consultancy-growth/artifacts/969fc7j5_PLACE%20copy.png"
          alt="PLACE Ventures"
          data-testid="footer-logo"
          className="h-16 md:h-20 w-auto object-contain [filter:brightness(0)_invert(1)]"
        />
        <span>© {new Date().getFullYear()} PLACE Ventures. All rights reserved.</span>
      </div>
    </div>
  </footer>
);
